module.exports = __webpack_public_path__ + "static/media/appvantage.da17e0d4.png";